import { Box, Grid, Skeleton, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

const SpinnerCard = () => {
    const { t } = useTranslation();
    return (
        <Grid container wrap="nowrap" style={{ position: 'relative' }}>
            <div style={{ position: 'absolute', transform: 'translate(-50%, 50%)', top: '10%', left: '50%', fontWeight: 600 }}>
                <Typography variant="h5">{t('spinner.title', { ns: 'common' })}</Typography>
                <br /> {t('spinner.subtitle', { ns: 'common' })}
            </div>
            {Array.from({ length: 3 }).map((_value: unknown, index: number) => (
                <Box key={`spinnerBox_${index}`} sx={{ width: 'calc(100% / 3)', marginRight: 0.5, my: 5 }}>
                    <Skeleton animation="pulse" variant="rectangular" width={'100%'} height={118} />
                    <Box sx={{ pt: 0.8 }}>
                        <Skeleton />
                        <Skeleton width="60%" />
                    </Box>
                </Box>
            ))}
        </Grid>
    );
};

export default SpinnerCard;
